import { ReactNode, useEffect, useState } from "react";
import { Box, Typography, Button, Paper, CircularProgress } from "@mui/material";
import { useLazyQuery, useMutation } from "@apollo/client";
import { SET_DEFAULT_LOCATION_MUTATION } from "ft-shared-graphql";
import { useSlideInContext } from "ui/SlideIn";
import { useNavigate } from "react-router";
import { LocationDataType } from "ft-shared-graphql/types";

function SelectionBox({
    isSelected,
    children,
    onClick
}: {
    isSelected: boolean;
    children: any;
    onClick: () => void
}) {
    if (!isSelected)
        return (
            <Paper
                elevation={1}
                sx={(p) => ({
                    padding: 3,
                    marginBottom: 2,
                    "&:hover": {
                        background: p.palette.primary.light,
                        color: p.palette.primary.contrastText,
                        cursor: 'pointer'
                    },
                })}
                onClick={onClick}
            >
                {children}
            </Paper>
        );

    return (
        <Paper
            elevation={5}
            sx={(p) => ({
                background: p.palette.primary.light,
                color: p.palette.primary.contrastText,
                padding: 3,
                marginBottom: 2
            })}
        >
            {children}
        </Paper>
    );
}

function Loading() {
    return (
        <Box display="flex" justifyContent="center">
            <CircularProgress />
        </Box>
    )
}

function LocationDetail(
    data: LocationDataType,
    // data: SelectLocation_LocationFragment,
    defaultLocationId: string,
    selectedLocationId: string | null | undefined,
    onClick: (location: LocationDataType) => void
    // onClick: (location: SelectLocation_LocationFragment) => void
) {
    if (!data) return;

    const filterUnusedComponents = (array: any) => array.filter((x: any) => x !== null && x !== '');

    // const addressSegmentL = filterUnusedComponents([data.streetAddressOne, data.streetAddressTwo, data.city]);
    const addressSegmentL = filterUnusedComponents([data.streetLineOne, data.streetLineTwo, data.city]);
    const addressSegmentR = filterUnusedComponents([data.state, data.postalCode, data.country]);
    const address = addressSegmentL.concat(addressSegmentR.join(' ')).join(', ');

    return (
        <SelectionBox isSelected={(!selectedLocationId && data.id === defaultLocationId) || data.id == selectedLocationId} onClick={() => onClick(data)}>
            <Typography style={{ fontSize: 16, fontWeight: "bold" }} align="left">
                {data.name}
            </Typography>
            <Box>
                <Typography align="left">
                    {address}
                </Typography>
            </Box>
        </SelectionBox>
    );
}

function DisablePanel({ disable, children }: { disable: boolean, children: any }) {
    return (
        <Box sx={{
            opacity: disable ? 0.5 : 1,
            pointerEvents: disable ? 'none' : 'initial'
        }}>
            {children}
        </Box>
    )
}
export type SelectLocationProps = {
    _locations: LocationDataType[],
    setDefaultLocation: (location: LocationDataType) => void,
    defaultLocation: LocationDataType
}
export default function SelectLocation({ _locations, setDefaultLocation, defaultLocation }: SelectLocationProps) {
    const navigate = useNavigate()

    const [mutationSetDefaultLocation, mutationSetDefaultLocationResponse] = useMutation(SET_DEFAULT_LOCATION_MUTATION)

    const { toggleDrawer } = useSlideInContext();

    const [selectedLocationId, setSelectedLocationId] = useState<string | null | undefined>(null);

    const handleLocationClick = (location: LocationDataType) => {
        if (!location) return;
        setSelectedLocationId(location.id);
        mutationSetDefaultLocation({
            variables: {
                id: location.id
            },
            onCompleted: () => {
                setDefaultLocation(location);
                toggleDrawer()
                navigate('/dashboard')
            }
        });
    }

    const handleCancel = () => {
        toggleDrawer()
    }
    return (
        <DisablePanel disable={mutationSetDefaultLocationResponse?.loading ?? false}>
            {/* {loading */}
            {!_locations
                ? <Loading />
                : _locations.map((x) =>
                    LocationDetail(
                        x,
                        defaultLocation?.id!,
                        selectedLocationId,
                        handleLocationClick
                    )
                )
            }
            <Box
                display="flex"
                alignItems="center"
                alignContent="center"
                justifyContent="center"
                mt={4}
            >
                <Box>
                    <Button onClick={handleCancel}>Cancel</Button>
                </Box>
            </Box>
        </DisablePanel>
    );
}
